export const createParserDefinition = () => {
    const InternalURIParsers = {};
    const declareInternalURIParser = (type, parser) => {
        if (!InternalURIParsers[type]) {
            InternalURIParsers[type] = parser;
        }
    };
    return [declareInternalURIParser, InternalURIParsers];
};
export const createSerializerDefinition = () => {
    const InternalURISerializers = {};
    const declareInternalURISerializer = (type, serializer) => {
        if (!InternalURISerializers[type]) {
            InternalURISerializers[type] = serializer;
        }
    };
    return [declareInternalURISerializer, InternalURISerializers];
};
//# sourceMappingURL=helpers.js.map